import { UserAddress } from "@/Models/User/Address";
import { UserProfile } from "@/Models/User/Profile";
import { AxiosResponseModel } from "@/Models/Utils/AxiosResponseModel";
import { ResponseModel } from "@/Models/Utils/ResponseModel";
import { AxiosResponse } from "axios";
import { Get, Post, PostFormData, Delete, Put } from "../Request/Api";
import { GetUser, RemoveUser, SetUser } from "../Request/Auth";

export default {
  state: {
    LoggedInUser: {},
    isLoggedIn: false,
    WebUser: null,
    AllAddress: null,
    userToken: null,
    loginPopup:false,
    redirectToPreviousRoute:"",
    BuyNowProductSavedId: null,
  },
  getters: {
    AuthenticateUser(state: any) {
      var user = GetUser();
      if (user) {
        state.LoggedInUser = user;
        state.isLoggedIn = true;
      } else {
        state.LoggedInUser = null;

        state.isLoggedIn = false;
      }

      // console.log(state.LoggedInUser);
      // console.log(state.rolePermission);
      return state.isLoggedIn;
    },
    isLoggedIn(state: any) {
      return state.isLoggedIn;
    },
    GetUser(state: any) {
      return state.LoggedInUser;
    },
    GetUserWeb(state: any): UserProfile {
      return state.WebUser;
    },
    GetAllAddress(state: any) {
      return state.AllAddress;
    },
  },
  actions: {
    async AddAddress({ commit }: any, payload: UserAddress) {
      return await Post("Account/AddUserAddress", payload).then(
        (res: AxiosResponse<AxiosResponseModel>) => {
          return res.data;
        }
      );
    },
    async GetAddress({ commit }: any, payload: Number) {
      return await Get(`Account/GetUserAddresses?UserId=${payload}`).then(
        (res: any) => {
          commit("SetUserAddresses", res.data.Data);
          return res.data.Data;
        }
      );
    },
    async GetMembershipPriceOnUserLocation({ commit }: any, payload: Number) {
      return await Get(`Membership/GetMembershipPriceByLocation`).then(
        (res: any) => {
          return res.data;
        }
      );
    },
    async CheckUserLogout({ getters, dispatch }: any) {
      const user = getters.GetUser;
      if (!user || !user.Id) return;
    
      return await Get(`Account/CheckUserLogout?userId=${user.Id}`).then((res: AxiosResponse<any>) => {
        if (res?.data?.Status) {
          dispatch("Logout");
          localStorage.removeItem("loginTime");
          return true;
        }
        return false;
      });
    },
    async UpdateAddress({ commit }: any, payload: object) {
      return await Post("Account/UpdateUserAddress", payload).then(
        (res: AxiosResponse<AxiosResponseModel>) => {
          console.log("update-address", res.data);
        }
      );
    },
    async SignUp({ commit }: any, payload: object) {
      console.log("test", payload);
      return await PostFormData("Account/signup", payload).then(
        (res: AxiosResponse<AxiosResponseModel>) => {
          console.log("update", res
          );
          return res.data
        }
      );
    },
    async Login({ commit }: any, payload: object) {
      return await Post("Account/Login", payload).then((res: any) => {
        commit("SetUser", res.data);
        localStorage.setItem("loginTime", Date.now().toString());
      });
    },
    async GetUserWeb({ commit }: any, payload: Number) {
      return await Get(`Account/GetUserWeb?id=${payload}`).then(
        (res: AxiosResponse<AxiosResponseModel>) => {
          console.log(res.data);
          commit("SetWebUser", res.data);
          return res.data;
        }
      );
    },
    async DeleteAddress({ commit }: any, payload: number) {
      return await Delete(`Account/DeleteUserAddresses?Id=${payload}`).then(
        (res) => {
          console.log(res);
        }
      );
    },
    async UpdateUsers({ commit }: any, payload: UserProfile) {
      return await PostFormData(`Account/UpdateUsers`, payload).then(
        (res: AxiosResponse<AxiosResponseModel>) => {
          console.log(res.data);
          return res.data;
        }
      );
    },
    ClearApiToken({ commit }: any) {
      commit("SetApiToken", null); // Set token in state to null
      localStorage.removeItem("apiToken"); // Remove token from local storage
    },
    async Logout({ commit, dispatch }: any, payload: object) {
      commit("LogoutUser", null);
      dispatch("ClearApiToken", null, { root: true });
      localStorage.removeItem("loginTime");
    },
    async UpdatePassword({ commit }: any, payload: object) {
      return await Put("User/ChangePassword", payload).then((res) => {
        console.log("UpdatePassword", res);
      });
    },
    async SendEmailForPassword({ commit }: any, payload: object) {
      return await Post(
        `User/SendLinkforResetPassword?email=${payload}`,
        payload
      ).then((res: AxiosResponse<AxiosResponseModel>) => {
        return res.data;
      });
    },
    async EmailVerificationforReset({ commit }: any, payload: object) {
      return await Post(
        `User/EmailVerificationforReset?token=${payload}`,
        payload
      ).then((res: AxiosResponse<AxiosResponseModel>) => {
        return res.data;
      });
    },
    async ResetPassword({ commit }: any, payload: object) {
      return await Post(`User/ResetPassword`, payload).then(
        (res: AxiosResponse<AxiosResponseModel>) => {
          return res.data;
        }
      );
    },
    async ConfirmUserAccount({ commit }: any, payload: any) {
      return await Post(`Account/ConfirmUserAccount?token=${payload.token}&userId=${payload.userId}`,{}).then(
        (res: any) => {
          return res.data;
        }
      );
    },
  },
  mutations: {
    SetUser(
      state: any,
      payload: {
        Id: number;
        Username: string;
        Email: string;
        ProfileImage: string;
        AccountType: number;
        LoginTokenResponseModel: { access_token: string; Role: object[] };
        UserMemeberships: {MembershipId: number}
        MembershipId: number;
      }
    ) {
      console.log(payload);
      var obj = {
        Id: payload.Id,
        Username: payload.Username,
        Email: payload.Email,
        AccountType: payload.AccountType,
        MembershipId: payload.MembershipId,
        ProfileImage:
          payload?.ProfileImage != null &&
          payload?.ProfileImage != undefined &&
          payload?.ProfileImage != ""
            // ? process.env.VUE_APP_IMG_URL + "/" + payload?.ProfileImage
            ? payload?.ProfileImage
            : payload?.ProfileImage,

        Access_Token: payload.LoginTokenResponseModel.access_token,
        MemberShipId: payload.UserMemeberships.MembershipId,
      };
      SetUser(obj);
      console.log(GetUser());
      state.LoggedInUser = obj;
      state.isLoggedIn = true;
    },
    SetWebUser(state: any, payload: ResponseModel) {
      (payload.Data.ProfileImage =
        payload.Data?.ProfileImage != null &&
        payload.Data?.ProfileImage != undefined &&
        payload.Data?.ProfileImage != ""
          // ? process.env.VUE_APP_IMG_URL + "/" + payload.Data?.ProfileImage
          ? payload.Data?.ProfileImage
          : payload.Data?.ProfileImage),
        (state.WebUser = payload.Data);
    },
    LogoutUser(state: any, payload: any) {
      RemoveUser();
      state.isLoggedIn = false;
      state.LoggedInUser = null;
    },
    SetUserAddresses(state: any, payload: any) {
      state.AllAddress = payload;
    },
  },
};
